import Ambassadors from "./pages/admin/Ambassadors";
import Campaigns from "./pages/admin/Campaigns";
import Dashboard from "./pages/admin/Dashboard";
import Donations from "./pages/admin/Donations";
import Integrations from "./pages/admin/Integrations/index";
import Calendar from "./pages/admin/Integrations/Calendar";
import Manage from "./pages/admin/CampaignDashboard/index";
import Profile from "./pages/admin/Profile";
import SelectStaffProfile from "./pages/admin/SelectStaffProfile";
import Subscription from "./pages/admin/Subscription";
import Authenticate from "./pages/Authenticate";
import Landing from "./pages/Landing";
import OrganizationRegistration from "./pages/admin/OrganizationRegistration";
import Pricing from "./pages/Pricing";
import Settings from "./pages/admin/Settings";
import OrganizationProfile from "./pages/admin/OrganizationProfile";
import InvitationCodes from "./pages/admin/InvitationCodes";
import ClassyIntegration from "./pages/admin/Integrations/Classy";

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing,
    layout: "/index",
    exact: true
  },
  // {
  //   path: "/",
  //   name: "Pricing",
  //   component: Pricing,
  //   layout: "/index",
  // },
  {
    path: "/authentication",
    name: "Create Your Organization Login",
    component: Authenticate,
    layout: "/auth",
  },
  {
    path: "/organization-registration",
    name: "Register Your Organization",
    component: OrganizationRegistration,
    layout: "/admin",
  },
  {
    path: "/select-organization",
    name: "Select Organization",
    component: SelectStaffProfile,
    layout: "/admin",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/campaigns",
    name: "Campaigns",
    component: Campaigns,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/fundraising/campaigns/manage",
    name: "Manage Campaign",
    component: Manage,
    layout: "/admin",
  },
  {
    path: "/ambassadors",
    name: "Ambassadors",
    component: Ambassadors,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    layout: "/admin",
  },
  {
    path: "/donations",
    name: "Donations",
    component: Donations,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/integrations/classy",
    name: "Classy Integration",
    component: ClassyIntegration,
    layout: "/admin",
    exact: true,
  },
  {
    path: "/integrations",
    name: "Integrations",
    component: Integrations,
    layout: "/admin",
    sidebar: true,
    exact: true,
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: Subscription,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/organization",
    name: "Organization Profile",
    component: OrganizationProfile,
    layout: "/admin"
  },
  {
    path: "/invitation-codes",
    name: "Organization Invitation Codes",
    component: InvitationCodes,
    layout: "/admin"
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: Calendar,
    layout: "/admin",
  },
];

export default routes;